import { useClientPortalAPI } from "@certn/api";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../../hooks/useQueryParams";

export function RoleFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();
  const { data, isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/roles/"
  );
  return (
    <Picker
      isLoading={isLoading}
      label={t("Role")}
      showActionBar
      selectionMode="multiple"
      selectedKeys={params.roles?.split(",") || []}
      onSelectionChange={(keys) => setParam("roles", Array.from(keys))}
      items={data}
      testID="role-filter-picker"
    />
  );
}
